export interface PartnerInfoItem {
  title: string;
  description?: string;
}

interface PartnerInformationSectionProps {
  heading?: string;
  items: PartnerInfoItem[];
  add_background?: boolean;
  add_bottom_border?: boolean;
}

export default function PartnerInformationSection({
  heading,
  items,
  add_background = false,
  add_bottom_border = false,
}: PartnerInformationSectionProps) {
  if (!items || items.length === 0) return null;

  const inner = (
    <div
      className={`w-full flex flex-col gap-6 ${
        add_bottom_border ? 'border-b border-gray-200 pb-10' : ''
      }`}
    >
      {heading && (
        <h2 className="text-primary-700 text-3xl font-bold">{heading}</h2>
      )}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {items.map((item, idx) => (
          <div
            key={idx}
            className="flex flex-col gap-1 p-4 rounded-xl border border-gray-100 bg-white shadow-sm"
          >
            <p className="text-primary-700 text-xl font-bold">{item.title}</p>
            {item.description && (
              <p
                className="text-gray-600 text-[18px] leading-relaxed"
                dangerouslySetInnerHTML={{ __html: item.description }}
              />
            )}
          </div>
        ))}
      </div>
    </div>
  );

  if (add_background) {
    return (
      <section className="w-screen relative left-1/2 right-1/2 -mx-[40vw] bg-[linear-gradient(to_bottom,rgba(237,237,249,0),#DEE5E8)] mb-8 py-8">
        <div className="container max-w-7xl mx-auto px-10 flex flex-col gap-6">
          {inner}
        </div>
      </section>
    );
  }

  return inner;
}
